import React from 'react';

class UnauthenticatedAlumniRegisterConfirmation extends React.Component {

  render() {
    return (
      <div className="account-wrapper">
        <p className="account-wrapper m-t-2 m-b-neg-1"><br /></p>

        <div className="account-body m-t-2">

          <h3 className="text-success m-b-05">Success!</h3>

          <h6 className="m-b-1 lh-18">
            You are now registered as an alumni on GCM
          </h6>
          <h6 className="m-t-1 lh-18">
            You will shortly be approved into your organization and will receive an email, giving you access to your alumni dashboard, calendar, message board, and more.
          </h6>

        </div>
      </div>
    );
  }

}

export default UnauthenticatedAlumniRegisterConfirmation;
